module.exports = __webpack_public_path__ + "static/media/05-img-06@3x.5b808b01.webp";